class MotorManualDatabase extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.groupedData = null;
    this.background = null;

    // Container to hold all dynamic HTML
    this.container = document.createElement("div");
    this.shadowRoot.appendChild(this.container);
  }

  static get observedAttributes() {
    return ["data"];
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    if (name === "data") {
      try {
        this.groupedData = JSON.parse(newValue);
        this.groupedData.forEach((group) => {
          group.links?.sort((a, b) => a.name.localeCompare(b.name));
        });
        await this.loadStylesheets(); // ensure CSS is ready
        this.render();
      } catch (err) {
        console.error("Failed to parse data:", err);
      }
    }
  }

  loadStylesheets() {
    const cssUrls = [
      "/cdn/shop/t/22/assets/webcomponent.css",
      "/cdn/shop/t/22/assets/tailwind.min.css",
    ];

    return Promise.all(
      cssUrls.map((href) => {
        return new Promise((resolve, reject) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = `${href}?v=${Date.now()}`;
          link.onload = resolve;
          link.onerror = reject;
          this.shadowRoot.appendChild(link);
        });
      })
    );
  }

  render() {
    if (!this.groupedData || !Array.isArray(this.groupedData)) return;

    const className = `card-container ${
      this.background === "#ffffff" ? "white" : ""
    }`;

    const tabsHTML = `
      <div class="custom-container">
        <div class="brand-list ${className}">
          ${this.groupedData
            .map(
              (group, index) => `
                <a data-tab-index="${index}" data-name="${group.name}" aria-selected="${
                index === 0
              }" class="brand-tab tab ${index === 0 ? "active" : ""}">
                  ${
                    group.image
                      ? `<div style="width: 50px" class="item">
                          <img src="${group.image}" class="center" loading="lazy">
                        </div>`
                   : `<div style="width: 50px; justify-content:center; text-align:center;" class="item">${group.name}</div>`
                  }
                </a>
              `
            )
            .join("")}
        </div>

        <div class="manuals ${className}">
          ${this.groupedData
            .map(
              (group, index) => `
                <div data-tab-index="${index}" class="manual-container group ${
                index !== 0 ? "hidden" : ""
              }">
                  ${group.links
                    .map(
                      (link) => `
                        <div class="manual-item">
                          <a class="block button--primary" ${
                            link.pdf ? `href="${link.pdf}" target="_blank"` : ""
                          }>
                            ${link.name}
                          </a>
                        </div>
                      `
                    )
                    .join("")}
                </div>
              `
            )
            .join("")}
        </div>
      </div>
    `;

    this.container.innerHTML = tabsHTML;

    this.container.querySelectorAll(".tab").forEach((tab) => {
      tab.addEventListener("click", this.handleTabClick.bind(this));
    });
  }

  handleTabClick(event) {
    const index = event.currentTarget.getAttribute("data-tab-index");

    this.container.querySelectorAll(".tab").forEach((tab) => {
      const tabIndex = tab.getAttribute("data-tab-index");
      tab.setAttribute("aria-selected", tabIndex === index);
      tab.classList.toggle("active", tabIndex === index);
    });

    this.container.querySelectorAll(".group").forEach((group) => {
      const groupIndex = group.getAttribute("data-tab-index");
      group.classList.toggle("hidden", groupIndex !== index);
    });
  }
}

customElements.define("motor-manual-database", MotorManualDatabase);
